import type {EnvironmentSubmit} from '../../../hooks/use-environment-selection'
import type {EnvironmentOption} from './environment-option'
import type {PreparedPrompt} from '@github-ui/ahp-session-client/contracts'
import type {McpPermissionMode} from '@github-ui/agent-sessions-types/mcp-permission-mode'

interface DispatchEnvironmentSubmissionInput {
  selectedEnvironment: EnvironmentOption | null
  onEnvironmentSubmit?: EnvironmentSubmit
  prompt: PreparedPrompt
  repositoryNwo?: string
  baseRef?: string
  mcpPermissionMode?: McpPermissionMode
}

export async function dispatchEnvironmentSubmission({
  selectedEnvironment,
  onEnvironmentSubmit,
  prompt,
  repositoryNwo,
  baseRef,
  mcpPermissionMode,
}: DispatchEnvironmentSubmissionInput): Promise<boolean> {
  const isRelayBacked = selectedEnvironment?.kind === 'ahp' || selectedEnvironment?.kind === 'sandbox'
  if (isRelayBacked && selectedEnvironment.environmentId && onEnvironmentSubmit) {
    await onEnvironmentSubmit({
      environmentId: selectedEnvironment.environmentId,
      prompt,
      ...(repositoryNwo ? {repositoryNwo} : {}),
      ...(baseRef ? {baseRef} : {}),
      ...(selectedEnvironment.kind === 'sandbox' ? {managedSandbox: true} : {}),
      ...(mcpPermissionMode ? {mcpPermissionMode} : {}),
    })
    return true
  }
  return false
}
